import { formatSecureCardNumberElement } from './formatSecureCardNumber';
import { isSecureCardNumberFilled } from './readSecureCardNumberText';
export function observeSecureCardNumberFilled(cardNumberId, onFilledChange) {
    const cardNumberElement = document.getElementById(cardNumberId);
    if (!cardNumberElement) {
        return () => undefined;
    }
    const syncCardNumberState = () => {
        formatSecureCardNumberElement(cardNumberElement);
        onFilledChange(isSecureCardNumberFilled(cardNumberElement));
    };
    syncCardNumberState();
    const MutationObserverCtor = globalThis.MutationObserver;
    if (!MutationObserverCtor) {
        return () => undefined;
    }
    const observer = new MutationObserverCtor(syncCardNumberState);
    observer.observe(cardNumberElement, {
        characterData: true,
        childList: true,
        subtree: true,
    });
    return () => {
        observer.disconnect();
    };
}
